export default __webpack_public_path__ + "static/boing-bounce-63d2de141275992c39f6adc791ba7efb.mp3";